export const showAppToast = ({ type = "info", title, message }) => {
  window.dispatchEvent(
    new CustomEvent("app:toast", {
      detail: {
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        type,
        title,
        message
      }
    })
  );
};

export const confirmAppAction = ({
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  type = "danger"
}) =>
  new Promise((resolve) => {
    window.dispatchEvent(
      new CustomEvent("app:confirm", {
        detail: {
          title,
          message,
          confirmLabel,
          cancelLabel,
          type,
          resolve
        }
      })
    );
  });
